import isString from "lodash/isString";
import { useEffect } from "react";

import { AVERAGE_FULL_SIZE_NAVIGATION_HEIGHT, FOOTER_HEIGHT } from "../constants";
import { getTopOffsetStyle } from "../helpers";

const EXTRA_SPACE = "var(--spacingLg)";

type UseSetHTMLStyles = {
  isEngagementBarVisible: boolean;
  isSmallScreen: boolean;
};

export const useSetHTMLStyles = ({ isEngagementBarVisible, isSmallScreen }: UseSetHTMLStyles) => {
  useEffect(() => {
    const stickyTopElementsHeight = isSmallScreen
      ? AVERAGE_FULL_SIZE_NAVIGATION_HEIGHT
      : getTopOffsetStyle(isEngagementBarVisible, isSmallScreen, EXTRA_SPACE);

    document.documentElement.style.scrollPaddingTop = isString(stickyTopElementsHeight)
      ? stickyTopElementsHeight
      : `${stickyTopElementsHeight}px`;
    document.documentElement.style.scrollPaddingBottom = `calc(${FOOTER_HEIGHT}px + ${EXTRA_SPACE})`;
    document.documentElement.style.scrollBehavior = "smooth";
  }, [isEngagementBarVisible, isSmallScreen]);
};

export const removeCustomActivityFormHTMLStyles = () => {
  document.documentElement.style.scrollPaddingTop = "";
  document.documentElement.style.scrollPaddingBottom = "";
  document.documentElement.style.scrollBehavior = "";
};
